package com.ustadmobile.mui.common

import web.cssom.px

object Sizes {
    object Header {
        const val HeightInPx = 64

        val Height = HeightInPx.px
    }

    object Sidebar {
        val WidthInPx = 180

        val Width = WidthInPx.px
    }
}
